module.exports = __webpack_public_path__ + "static/img/ssszdq-details.4ea8e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ssszdq-details.png
// module id = 8PUm
// module chunks = 0